const STATE = 'state';

export { STATE };
